// displayed products
export const description = "sm:pb-[1rem] max-sm:pb-[1rem]";
export const textDescription = "font-poppins  text-[16px] leading-[22.96px] tracking-[2%] text-[#004B95] font-normal ";
export const displayHeading = " text-[18px] leading-[131%] tracking-[0.055em] font-bold not-italic font-poppins text-[#004B95] text-[#004B95]";

// matrix
export const transformMatrix = "matrix(1, 0, 0, 1, 50, 50)";
